// extracted by mini-css-extract-plugin
export default {"menuItem":"MenuItem_menuItem__V4n5Z"};